/*
 * Module for the confirm-before-submit button attribute
*/
rs.module("common/confirm-before-submit",

    [],

    function () {

        // Initialize the module
        function initialize() {

            // The confirm-before-submit button currently being interacted with
            var confirmBeforeSubmitButton;

            var confirmTextAttribute = "confirmtext";
            var originalTextAttribute = "originaltext";

            // Handle click of a confirm-before-submit button
            $(document).on("click", "[confirm-before-submit]", function (event) {

                // store reference to the confirm-before-submit button being interacted with
                confirmBeforeSubmitButton = $(this);

                // set default confirmtext if missing
                if (!confirmBeforeSubmitButton.data(confirmTextAttribute)) {
                    confirmBeforeSubmitButton.data(confirmTextAttribute, "Are you sure?");
                } 

                // if the button was clicked for the first time (i.e,, it's not displaying the confirmation text),
                // then prevent the post and update the button's styling and text
                if (confirmBeforeSubmitButton.text() != confirmBeforeSubmitButton.data(confirmTextAttribute)) {

                    //prevent the post
                    event.preventDefault();

                    // save the original text
                    if (!confirmBeforeSubmitButton.data(originalTextAttribute)) {
                        confirmBeforeSubmitButton.data(originalTextAttribute, confirmBeforeSubmitButton.text());
                    }

                    // change to confirmation text and update the button's styling
                    confirmBeforeSubmitButton.text(confirmBeforeSubmitButton.data(confirmTextAttribute));
                    confirmBeforeSubmitButton.addClass("_no-hover");
                    if (confirmBeforeSubmitButton.hasClass("btn-outline-primary")) {
                        confirmBeforeSubmitButton.removeClass("btn-outline-primary");
                        confirmBeforeSubmitButton.addClass("btn-primary");
                    }
                    else {
                        confirmBeforeSubmitButton.removeClass("btn-primary");
                        confirmBeforeSubmitButton.addClass("btn-outline-primary");
                    } 
                }
            });

            // Handle clicks off of the currently interactive confirm-before-submit button
            $(document).click(function (e) {

                if (confirmBeforeSubmitButton && !confirmBeforeSubmitButton.is(e.target)) {

                    // change to original text and revert the button's styling to it's original state
                    confirmBeforeSubmitButton.text(confirmBeforeSubmitButton.data(originalTextAttribute));
                    confirmBeforeSubmitButton.removeClass("_no-hover");
                    if (confirmBeforeSubmitButton.hasClass("btn-primary")) {
                        confirmBeforeSubmitButton.removeClass("btn-primary");
                        confirmBeforeSubmitButton.addClass("btn-outline-primary");
                    }
                    else {
                        confirmBeforeSubmitButton.removeClass("btn-outline-primary");
                        confirmBeforeSubmitButton.addClass("btn-primary");
                    }

                    // Clear our reference to the confirm-before-submit button since it's no longer being interacted with
                    confirmBeforeSubmitButton = null;
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);